// extracted by mini-css-extract-plugin
module.exports = {"header":"DiningOptionSelector__header___3ZFXM","flex":"DiningOptionSelector__flex___3kvLL","errorMessage":"DiningOptionSelector__errorMessage___XA24p"};